export default __webpack_public_path__ + "static/media/legal-papers.ab4fc530.jpg";